{
  "RRSP": "REER",
  "TFSA": "CELI",
  "PERSONAL": "Cuenta de Efectivo",
  "RESP": "REEE",
  "RESP_SINGLE": "REEE Individual",
  "RESP_FAMILY": "REEE Familiar",
  "RESP_ADULT": "REEE para Adultos",
  "CORPORATE_CASH": "Cuenta de Efectivo Corporativa",
  "CORPORATE_TRUST": "Fideicomisos",
  "CORPORATE_ESTATE": "Patrimonio Corporativo",
  "CORPORATE_CHARITY": "Caridad Corporativa",
  "RRSP_SPOUSAL": "REER Conyugal",
  "LIRA": "LIRA",
  "RRIF": "FERR",
  "RIF_SPOUSAL": "FERR Conyugal",
  "LIF": "LIF",
  "PRIF": "PRIF",
  "GRSP": "GRSP",
  "CASH_JOINT": "Cuenta de Efectivo Conjunta",
  "RDSP": "RDSP",
  "RDSP_JOINT": "RDSP Conjunto",
  "MARGIN": "Margen",
  "MARGIN_JOINT": "Margen Conjunto",
  "RESP_SINGLE_JOINT": "REEE Individual Conjunto",
  "RESP_FAMILY_JOINT": "REEE Familiar Conjunto",
  "INFORMAL_TRUST": "Fideicomiso Informal",
  "INFORMAL_TRUST_JOINT": "Fideicomiso Informal Conjunto",
  "FHSA": "CELIAPP",
  "RLSP": "RLSP",
  "LRSP": "LRSP",
  "RLIF": "RLIF",
  "LRIF": "LRIF",
  "DBPP": "DBPP",
  "IPP": "IPP",
  "RPP": "RPP",
  "USA_BROKERAGE": "Corretaje Individual",
  "USA_IRA": "IRA Tradicional",
  "USA_RO_IRA": "IRA de Transferencia",
  "USA_RT_IRA": "IRA Roth",
  "USA_INH_IRA": "IRA Heredada",
  "USA_INH_RT_IRA": "IRA Roth Heredada",
  "USA_JT_WROS": "Cuenta de Inquilino Conjunto (JTWROS)",
  "USA_JT_JTBE": "Arrendamiento Conjunto por Totalidad",
  "USA_JT_TIC": "Inquilino Conjunto (TIC)",
  "USA_JT_CP": "Inquilino Conjunto (CP)",
  "USA_SEP_IRA": "IRA de Pensión Simplificada para Empleados",
  "USA_401K": "401(k) Patrocinado por el Empleador",
  "USA_SOLO_401K": "401(k) Individual",
  "USA_TRUST": "Cuenta Fiduciaria",
  "USA_CORPORATE": "Cuenta(s) Corporativa(s)",
  "USA_ESA": "Cuenta de Ahorro para Educación",
  "USA_529": "Plan de Ahorro 529",
  "UK_BROKERAGE": "Cuenta General",
  "UK_CASH_ISA": "Cuenta de Ahorros Individual en Efectivo (ISA)",
  "UK_SS_ISA": "Cuenta de Ahorros Individual en Acciones y Valores (ISA)",
  "UK_JISA": "Cuenta de Ahorros Individual Junior (JISA)",
  "UK_PERSONAL_PENSION": "Pensión Personal",
  "USA_TOD": "Corretaje Individual - TOD",
  "USA_ESTATE": "Patrimonio",
  "USA_DAF": "Fondo Asesorado por Donantes",
  "USA_SIMPLE_IRA": "IRA SIMPLE",
  "USA_KEOGH": "Plan Keogh / HR-10",
  "USA_CUSTODIAL": "Cuenta de Custodia",
  "USA_IRA_CUSTODIAL": "IRA de Custodia (para Menores)",
  "USA_DBP": "Plan de Beneficios Definidos",
  "USA_CRA": "Cuenta de Jubilación de la Empresa / Fideicomiso de Pensiones",
  "USA_MARGIN": "Cuenta de Margen Individual",
  "USA_JT_WROS_MARGIN": "Cuenta de Margen de Inquilino Conjunto (JTWROS)",
  "USA_JT_TIC_MARGIN": "Margen de Inquilino Conjunto (TIC)",
  "USA_JT_JTBE_MARGIN": "Margen de Inquilinos Conjuntos por Totalidad",
  "USA_JT_CP_MARGIN": "Margen de Inquilino Conjunto (CP)",
  "EXTERNAL": "Externo",
  "INVESTMENT": "Inversión",
  "PENSION_PLAN": "Plan de Pensión"
}
